/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { baselineAppStyles} from '@insticator/insticator-ui'
import { themeV2 } from 'utils/themeV2';


const baselineAppGlobalStyles = {
	'.loader': {
		'& div': {
			borderTopColor: `${themeV2.color.primary.main} !important`
		}
	}
}
const baselineStyles = {
	...baselineAppStyles,
	'@global': {
		...baselineAppStyles['@global'],
		...baselineAppGlobalStyles
	}
}
/* ++++++++++ --------------- EXPORT : APP : STYLES --------------- ++++++++++ */
export default theme => ({
	...baselineStyles
});